module.exports = __webpack_public_path__ + "static/img/foot_bg.5fe26d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/foot_bg.png
// module id = oJSM
// module chunks = 1